import { render, staticRenderFns } from "./purchasedPacketModal.vue?vue&type=template&id=65294755&scoped=true&"
import script from "./purchasedPacketModal.vue?vue&type=script&lang=js&"
export * from "./purchasedPacketModal.vue?vue&type=script&lang=js&"
import style0 from "./purchasedPacketModal.vue?vue&type=style&index=0&id=65294755&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65294755",
  null
  
)

export default component.exports